const STORAGE_KEY = "allstar-pending-clip-creations";
const TTL_MS = 60 * 1000; // 1 minute

export const addPendingClipCreation = (): void => {
  const pending = getStoredTimestamps();
  pending.push(Date.now());
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
};

export const getPendingClipCount = (): number => {
  const now = Date.now();
  const pending = getStoredTimestamps().filter((ts) => now - ts < TTL_MS);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(pending));
  return pending.length;
};

export const clearPendingClipCreations = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};

const getStoredTimestamps = (): number[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((v): v is number => typeof v === "number");
  } catch {
    return [];
  }
};
